import script from "./CourseScheduleWorkspace.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseScheduleWorkspace.vue?vue&type=script&setup=true&lang=js"

import "./CourseScheduleWorkspace.vue?vue&type=style&index=0&id=53f5844c&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/AIDean/dean_dhses_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53f5844c"]])

export default __exports__